<template>
  <div class="sidebar">
    <el-menu
      :default-active="activeIndex"
      router
      class="el-menu-vertical-demo"
      :collapse="isCollapse"
      background-color="#031F3B"
      text-color="#FFFFFF"
      active-text-color="#fff"
      :unique-opened="true"
      :style="{height:menuHeight+'px','overflow-y':'auto'}"
    >
      <el-menu-item
        v-for="child in functionMenu"
        v-bind:key="child.powerCode"
        :index="child.powerUrl"
        :class="child.isCheck?'menu_select':''"
      >
        <i :class="child.powerIcon"></i>
        <span slot="title">{{child.powerName}}</span>
      </el-menu-item>
      <el-submenu :index="menu.powerUrl" v-for="menu in moduleMenu" v-bind:key="menu.powerName">
        <template slot="title">
          <i :class="menu.powerIcon"></i>
          <span slot="title">{{menu.powerName}}</span>
        </template>
        <el-menu-item
          v-for="child in menu.children"
          v-bind:key="child.powerName"
          :index="child.powerUrl"
          :class="child.isCheck?'menu_select':''"
        >{{child.powerName}}</el-menu-item>
      </el-submenu>
    </el-menu>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Sidebar",
  data() {
    return {
      menuHeight: 0,
      menus: [],
      functionMenu: [],
      moduleMenu: []
    };
  },
  computed: {
    ...mapGetters(["sidebar"]),
    isCollapse() {
      return !this.sidebar.opened;
    },
    activeIndex() {
      const thisRoutPath = this.$route.path;
      let routPath1 = thisRoutPath.split("/")[1];
      let routPath2 = thisRoutPath.split("/")[2];
      this.menus.forEach(e => {
        if (e.powerUrl.replace("/", "") == routPath1) {
          if (e.children.length == 0) {
            e.isCheck = true;
          } else {
            e.children.forEach(ele => {
              if (ele.powerUrl == thisRoutPath) {
                ele.isCheck = true;
              } else {
                ele.isCheck = false;
              }
            });
          }
        } else {
          if (e.children.length == 0) {
            e.isCheck = false;
          } else {
            e.children.forEach(ele => {
              ele.isCheck = false;
            });
          }
        }
      });
      return thisRoutPath;
    }
  },
  mounted() {
    var that = this;
    this.menuHandle();
    this.$nextTick(function() {
      var clientHeight = document.body.clientHeight; //屏幕高度
      var headerHeight = document.getElementsByClassName("header")[0]
        .scrollHeight; //header高度
      that.menuHeight = clientHeight - headerHeight;
    });
  },
  methods: {
    //路由处理
    menuHandle() {
      var that = this;
      var menus = this.$storage.getMenus();
      var user = this.$storage.getUser();
      this.moduleMenu = []; //模块路由
      this.functionMenu = []; //功能路由
      menus.forEach(e => {
        if (
          !(user.unitId == window.globle.unit && e.powerUrl == "/dataKanban") &&
          !(user.unitId != window.globle.unit && e.powerUrl == "/platKanban")
        ) {
          if (e.powerType == 2) {
            that.functionMenu.push(e);
          } else {
            that.moduleMenu.push(e);
          }
          that.menus.push(e);
        }
      });
    }
  }
};
</script>

<style scoped>
.sidebar {
  background-color: #031f3b;
  margin: 0 auto;
  height: 100%;
}

.menu_select {
  background-color: #3371c9 !important;
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
}

.el-menu-item.is-active,
.el-submenu.is-active >>> .el-submenu__title {
  color: #fff !important;
}

.el-submenu .el-menu-item {
  padding-left: 60px !important;
  min-width: auto;
}

.el-submenu {
  list-style: none;
  margin: 0;
  padding-left: 0;
  text-align: left;
}

.el-submenu .el-menu-item:hover {
  padding-left: 60px !important;
  background: #4970c9 !important;
}

.el-menu-item {
  text-align: left;
}

.el-menu-item i {
  padding-bottom: 4px;
}

.el-submenu__title i {
  padding-bottom: 4px;
}

@media all and (max-width: 768px) {
  .el-menu--collapse {
    width: 0;
    overflow: hidden;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/sidebar/Sidebar.vue